import React from 'react'

const ChevronDownIcon = props => (
  <svg width="24"
       height="24"
       viewBox="0 0 24 24"
       focusable="false"
       role="presentation" {...props}>
    <path
      d="M8.664 9.504l4.263-6.395A2 2 0 0011.263 0H2.737a2 2 0 00-1.664 3.11l4.263 6.394a2 2 0 003.328 0z"
      fill="#152735"
      fillRule="evenodd"
    />
  </svg>
)

export default ChevronDownIcon
